import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { initializeNotification } from "~/redux/modules/admin/data";
import {
  setLoading,
  setSuccess,
  setError,
  resetAlert,
} from "~/redux/modules/admin/screen";
import { RootState } from "~/redux/rootReducer";
import { Notification } from "~/types/notification";
import { Event } from "~/types/component";
import { notificationsCollection } from "~/const/firestore";

export type Module = ReturnType<typeof useModule>;

export const useModule = () => {
  const dispatch = useDispatch();

  // 画面の状態を制御
  const startLoading = () => dispatch(setLoading(true));
  const stopLoading = () => dispatch(setLoading(false));
  const resetAlertMessage = () => dispatch(resetAlert());
  const setSuccessMessage = (val: string) => dispatch(setSuccess(val));
  const setErrorMessage = (val: string) => dispatch(setError(val));

  // 通知データ
  const notifications = useSelector(
    (state: RootState) => state.adminData.notifications
  );
  const isNotificationInit = useSelector(
    (state: RootState) => state.adminData.isNotificationInit
  );

  // 通知を作成
  const initialNotificationValue: Notification = {
    title: "",
    message: "",
    created: new Date(),
  };
  const [dialogData, setDialogData] = useState<Notification>(
    initialNotificationValue
  );
  const changeValue = (e: Event, key: keyof Notification) => {
    setDialogData({ ...dialogData, [key]: e.target.value });
  };
  const registorNotification = async () => {
    startLoading();
    setOpenDialog(false);
    resetAlertMessage();

    setDialogData({ ...dialogData, created: new Date() }); // 登録日をセット

    try {
      await notificationsCollection.add(dialogData);
      setTimeout(() => setSuccessMessage("通知の登録をしました"), 100);
      dispatch(initializeNotification());
    } catch (error) {
      console.log(error);
      setErrorMessage("通知の登録に失敗しました");
    } finally {
      stopLoading();
    }
  };

  // ページネーション
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const handleChangePage = (_: unknown, newPage: number) => setPage(newPage);
  const handleChangeRowsPerPage = (event: Event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // ダイアログ
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const handleOpenDialog = (data?: Notification) => {
    if (data) {
      setDialogData(data);
    } else {
      setDialogData(initialNotificationValue);
    }
    setOpenDialog(true);
  };
  const handleCloseDialog = () => setOpenDialog(false);

  return {
    states: {
      openDialog,
      dialogData,
      isNotificationInit,
      notifications,
      page,
      rowsPerPage,
    },
    setters: {
      handleCloseDialog,
      handleOpenDialog,
      changeValue,
      handleChangePage,
      handleChangeRowsPerPage,
    },
    actions: {
      registorNotification,
    },
  };
};
